import styled from "styled-components";
import ceskeDrahyLogo from "../../img/firms/cd.png";
import zcuLogo from "../../img/firms/zapadoceska-logo.png";
import NilanLogo from "../../img/firms/Nilan_logo.png";
import Neanderthales from "../../img/icons/Neanderthales.png";
import {FaLongArrowAltRight} from "react-icons/fa";
import Fade from 'react-reveal/Fade';
function Reference(props){
    return(
        <Ref className={props.name}>
            <Point></Point>
            <ReferenceText>
                <div className="ReferenceTitle">
                    {props.title}
                </div>
                <div className="ReferenceDescription">
                    {props.description}
                </div>
            </ReferenceText>
            <Logo>
                <Circle>
                    <img
                        src={props.img}
                        alt={props.imgAlt}
                    />
                </Circle>
            </Logo>
            <Link className={props.type}>
                {/*<a
                    href={props.link}
                >
                    <div>
                        Zjistit více
                    </div>
                    <FaLongArrowAltRight />
                </a>*/}
            </Link>
        </Ref>
    );
}
const Logo = styled.div`
  position:absolute;
  top:40px;
  right:40px;
`;
const Circle = styled.div`
  border-radius: 50%;
  width:72px;
  height: 72px;
  background-color:white;
  border:1px solid #D3D3D3;
  padding:10px;
  display:flex;
  justify-content: center;
  align-items: center;
  img{
    max-width:60px;
  }
  @media only screen and (max-width: 499px){
    width:42px;
    height: 42px;
    img{
      max-width:34px;
    }
  }
`;
const Ref = styled.div `
  position:relative;
  
  width:425px;
  height:280px;
  border-radius: 20px;
  flex: 0 0 32%;
  @media only screen and (min-width: 900px) and (max-width: 1399px){
    flex: 0 0 48%;
    margin-bottom: 40px;
  }
  @media only screen and (max-width: 900px){
    width: 100%;
    margin-bottom:30px;
  }
`;
const ReferenceText = styled.div `
  padding-top:60px;
  width:73%;
  margin:0 auto;
  
  .ReferenceTitle{
    font-size:24px;
    font-weight: bold;
    padding-bottom:4px;
    width: 70%;
  }
  .ReferenceDescription{
    font-size:17px;
    width: 70%;
  }
  @media only screen and (max-width: 499px){
    padding-top:40px;
  }
`;
const Point = styled.div`
    position:absolute;
    top:31px;
    left:31px;
    width:25px;
    height: 25px;
    border-radius:50%;
    background-color:black;
    opacity:0.4;
    @media only screen and (max-width: 499px) {
      display: none;
    }
`;
const Link = styled.div`
  position:absolute;
  bottom: 24px;
  left: 50%;
  transform: translate(-50%, -50%);


  a{
    text-decoration: none;
    font-weight: bold;
    font-size:18px;
    display:flex;
    align-items: center;
  }
  svg{
    padding-left:10px;
    font-size:24px;
  }
`;

function References(){
    return(
        <Block>
            <div className="layout blocks-padding">
                <TitleFirst className="fade-up-1 h-1">
                    <Fade top>
                    Nezakleneme se,
                    </Fade>
                </TitleFirst>
                <TitleSecond className="fade-up-1 h-1">
                    <Fade top>
                    TĚŽKÝCH ÚKOLŮ
                    </Fade>
                </TitleSecond>
                <MainAction>
                    <div className="MainActionFlexOne">
                        <div>
                            <img className="MainActionImg" src={Neanderthales} alt=""/>
                        </div>
                    </div>
                </MainAction>
                <ReferenceList>
                    <Flex>
                        <Reference title="Západočeská univerzita v Plzni" description="Úkol zněl jasně, vytvořit nové webovky" img={zcuLogo} name="zcu" imgAlt="" link=""/>
                        <Reference title="České dráhy" description="ERP rental systém" img={ceskeDrahyLogo} name="ceskeDrahy" imgAlt="" link=""/>
                        <Reference title="NILAN" description="Logistika, ERP" img={NilanLogo} name="nilan" imgAlt="" link=""/>
                    </Flex>
                </ReferenceList>
                <ButtonBlock className="button-padding-1 f-inter">
                    {/*<Button>*/}
                    {/*        Zobrazit všechny reference*/}
                    {/*</Button>*/}
                </ButtonBlock>
            </div>
        </Block>
    );
}
const Block = styled.div`
    background-color:white;
`;
const TitleFirst = styled.div`
  color:var(--main-color);
  font-weight: normal;
`;
const TitleSecond = styled.div`
  font-size:48px;
`;
const MainAction = styled.div`
  position:relative;
  width:auto;
  height: 400px;
  display:flex;
  .MainActionImg{
    @media only screen and (max-width: 699px){
      margin: 20px 0 60px 0; 
      width:100%;
    }
  }
  .MainActionFlexOne{
    flex:1;
  }
  .Reference-action{
    padding-top:70px;
  }
  @media only screen and (max-width: 1399px){
    .Reference-action{
      display:none;
    }
    display:block;
  }
  @media only screen and (max-width: 699px){
    height: auto;
  }
  
`;
const Flex = styled.div`
  display:flex;
  justify-content: space-between;
  @media only screen and (max-width: 1400px){
    flex-wrap: wrap;
  }
  @media only screen and (max-width: 900px){
    display:block;
  }
`;
const ReferenceList = styled.div`
  
`;
const ButtonBlock = styled.div`
  display:flex;
  justify-content: center;

  a{
    color:white;
    font-weight: bold;
    font-size:20px;

    text-decoration: none;
  }
`;
export default References;